// extracted by mini-css-extract-plugin
export default {"container":"zZ-z","list":"AZ-z"};